import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 20,
};

export const certificatesUnsignedListTableController = createSlice({
    name: 'certificatesUnsignedListTableController',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const { changeCurrentPage } = certificatesUnsignedListTableController.actions;

export default certificatesUnsignedListTableController.reducer;